import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Onoboarding from 'components/Onboarding';
import { useDispatch, useSelector } from 'react-redux';
import { actions, selectors } from 'ducks/onboarding';

const Home = ({
  match: {
    params: { brand },
  },
}) => {
  console.log('home');

  const dispatch = useDispatch();

  useEffect(() => {
    const requestOnboarding = () => dispatch(actions.request(brand));
    requestOnboarding();
  }, [brand, dispatch]);
  const data = useSelector(selectors.get);
  const propsBag = {
    logger: () => {},
  };
  return <Onoboarding data={data} propsBag={propsBag} />;
};

Home.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Home;
